<template>
  <div class="py-4">
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div v-if="!loading" class="align-middle inline-block min-w-full justify-center">
          <div class="bg-white overflow-hidden shadow rounded-lg border border-gray-200 divide-y divide-gray-200 mb-4" v-for="order in orders" :key="order.uuid">
            <!-- Cabecera: ID + copiar | icono de estado -->
            <div class="px-4 py-3 flex items-center justify-between">
              <div class="flex items-center gap-1">
                <span class="text-sm font-medium font-mono text-gray-900" :title="order.uuid">{{ order.uuid.substring(0, 8) }}…</span>
                <button type="button" class="text-gray-400 hover:text-gray-600 focus:outline-none" @click="copyOrderId(order)" :title="$t('sales.copy_id')" :aria-label="$t('sales.copy_id')">
                  <font-awesome-icon :icon="copiedUuid === order.uuid ? 'check' : 'copy'" :class="copiedUuid === order.uuid ? 'text-green-600' : ''" class="h-3.5 w-3.5" />
                </button>
              </div>
              <font-awesome-icon :icon="orderStatusIcon(order.status).icon" :class="orderStatusIcon(order.status).color" class="h-4 w-4" :title="orderStatusIcon(order.status).label" />
              <span class="sr-only">{{ orderStatusIcon(order.status).label }}</span>
            </div>

            <!-- Fecha -->
            <div class="px-4 py-3 text-sm text-gray-700">
              {{ $t('general.date') }}: {{ $moment(order.completed_at).format('DD/MM/YYYY') }}
            </div>

            <!-- Cliente -->
            <div class="px-4 py-3">
              <router-link v-if="order.customer && order.customer.uuid" :to="{ name: 'user-profile', params: { id: order.customer.uuid }}" class="cursor-pointer hover:text-blue-800 hover:underline">
                <div class="text-sm font-medium text-bpblue">{{ order.customer.firstname + ' ' + order.customer.lastname }}</div>
                <div v-if="order.customer.email" class="text-sm font-light text-bpblue">{{ order.customer.email }}</div>
              </router-link>
              <template v-else>
                <div v-if="order.customer" class="text-sm font-medium text-gray-900">{{ order.customer.firstname + ' ' + order.customer.lastname }}</div>
                <div v-if="order.customer.email" class="text-sm font-light text-gray-900">{{ order.customer.email }}</div>
              </template>
              <div v-if="order.customer.phone" class="text-sm font-light text-gray-500 mt-0.5">{{ order.customer.phone }}</div>
            </div>

            <!-- Productos -->
            <div class="px-4 py-3">
              <div v-for="item in order.items" :key="item.uuid" class="mb-2 last:mb-0">
                <div class="text-sm text-gray-700">{{ parseItemTitle(item.title).name }}</div>
                <span v-for="(coupon, index) in parseItemTitle(item.title).coupons" :key="index" class="inline-flex items-center gap-1 mr-1 mt-1 px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 whitespace-nowrap">
                  <font-awesome-icon icon="ticket-alt" class="h-3 w-3" />
                  {{ coupon.code }} -{{ coupon.amount }}{{ coupon.symbol }}
                </span>
              </div>
            </div>

            <!-- Total -->
            <div class="px-4 py-3 flex items-baseline justify-between">
              <span class="text-sm text-gray-500">{{ $t('general.total') }}</span>
              <span class="flex items-baseline gap-2">
                <span class="text-xs text-gray-400">{{ $t('general.net') }}: {{ order.net }}€</span>
                <span class="text-xl font-bold text-gray-900">{{ order.total }}€</span>
              </span>
            </div>
          </div>
        </div>
        <loading-component v-else>{{$t('sales.loading_products')}}</loading-component>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingComponent from "@/views/common/LoadingComponent";

export default {
  name: "OrdersComponent",
  components: {LoadingComponent},
  props: {
    orders: Array,
    loading: Boolean
  },
  data() {
    return {
      copiedUuid: null
    }
  },
  methods: {
    parseItemTitle(title) {
      const couponSuffix = /\s-\s\(#([^/]+?)\s\/\s([\d.,]+)\s*(%|EUR)?\)/g

      const coupons = []
      let match
      while ((match = couponSuffix.exec(title)) !== null) {
        coupons.push({ code: match[1].trim(), amount: match[2].trim(), symbol: match[3] || '' })
      }

      const name = title.replace(/\s-\s\(#([^/]+?)\s\/\s([\d.,]+)\s*(%|EUR)?\)/g, '').trim()

      return { name, coupons }
    },
    orderStatusIcon(status) {
      const statuses = {
        completed:  { icon: 'check',   color: 'text-green-600',  label: this.$t('sales.complete') },
        processing: { icon: 'spinner', color: 'text-blue-600',   label: this.$t('sales.processing') },
        pending:    { icon: 'clock',   color: 'text-yellow-600', label: this.$t('sales.pending') },
        on_hold:    { icon: 'pause',   color: 'text-orange-600', label: this.$t('sales.on_hold') },
        refunded:   { icon: 'undo',    color: 'text-purple-600', label: this.$t('sales.reimbursed') },
        failed:     { icon: 'times',   color: 'text-red-600',    label: this.$t('sales.failed') },
        cancelled:  { icon: 'ban',     color: 'text-gray-500',   label: this.$t('sales.cancelled') },
        trash:      { icon: 'trash',   color: 'text-gray-700',   label: this.$t('sales.trashed') },
      }

      return statuses[status] || { icon: 'ban', color: 'text-gray-400', label: status }
    },
    copyOrderId(order) {
      navigator.clipboard.writeText(order.uuid).then(() => {
        this.copiedUuid = order.uuid
        setTimeout(() => {
          if (this.copiedUuid === order.uuid) this.copiedUuid = null
        }, 1500)
      }).catch((error) => {
        console.log("No se pudo copiar el ID del pedido", error)
      })
    }
  }
}
</script>

<style scoped>

</style>